import { Article } from './Article';
import { BreadcrumbList } from './BreadcrumbList';
import { EntertainmentBusiness } from './EntertainmentBusiness';
import { FAQPage } from './FAQPage';
import { Organization } from './Organization';
import { Product } from './Product';
import { WebPage } from './WebPage';
import { WebSite } from './WebSite';

export const structuredData = {
  Article,
  BreadcrumbList,
  EntertainmentBusiness,
  FAQPage,
  Organization,
  Product,
  WebPage,
  WebSite,
};
